import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { BookingModel, CreateVehicle, UserModel } from '../Api_Module';
import { Roles } from '../models/roles.enum';

@Injectable()
export class AuthenticationService {

  constructor() {
  }

  isLoggegIn(): boolean {
    const user: UserModel = JSON.parse(localStorage.getItem('currentUser'));
    return !!user && !!user.token && user.token.length && !!user.role ;
  }

  userRole(): string {
    const user: UserModel = JSON.parse(localStorage.getItem('currentUser'));
    return !!user && !!user.token && user.token.length ? user.role : null ;
  }

  userFullNames(): string {
    const user: UserModel = JSON.parse(localStorage.getItem('currentUser'));
    return !!user && !!user.token && user.token.length ? `${user.firstName} ${user.lastName}` : null ;
  }

  userObj(): UserModel {
    const user: UserModel = JSON.parse(localStorage.getItem('currentUser'));
    return !!user && !!user.token && user.token.length ? user : null ;
  }

  isUserInRoles(roles: any[]) {
    return roles.length < 1 || !!roles.find((role) => !!role && !!this.userRole() &&  role.toLowerCase() === this.userRole().toLowerCase());
  }

  getCustomerId(): number {
    const user: UserModel = JSON.parse(localStorage.getItem('currentUser'));
    return !!user && !!user.customerId ? user.customerId : null;
  }

  getAgencyId(): number {
    const user: UserModel = JSON.parse(localStorage.getItem('currentUser'));
    return !!user && !!user.agencyId ? user.agencyId : null;
  }

  getUserId(): number {
    const user: UserModel = JSON.parse(localStorage.getItem('currentUser'));
    return !!user && !!user.id ? user.id : null;
  }

  isAdmin(): boolean {
    return this.userRole() === Roles.Administrator;
  }

  isStaff() {
    return this.userRole() === Roles.Client_Liason_Officer || this.isAdmin();
  }

  isClient() {
    return this.userRole() === Roles.Client;
  }

  isAgent() {
    return this.userRole() === Roles.Agent || this.isAgencyAdmin();
  }

  isAgencyAdmin() {
    return this.userRole() === Roles.AgencyAdministrator;
  }

}
